import React, { useEffect, useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Snackbar as RNSnackbar, Portal } from 'react-native-paper';
import MuiSnackbar from '@material-ui/core/Snackbar';
import { snackbarService, SnackbarPayload } from '../../../services/snackbar.service';
import colors from '../../../config/colors';
import ImageIcon from '../Icon/ImageIcon.component';
import I18n from '../i18n/I18n.component';

const SnackbarContainer = () => {
	const [payload, setPayload] = useState<SnackbarPayload | null>(null);

	useEffect(() => {
		return snackbarService.subscribe(setPayload);
	}, []);

	const hide = () => snackbarService.hide();

	if (Platform.OS === 'web') {
		return (
			<MuiSnackbar
				open={!!payload}
				onClose={hide}
				autoHideDuration={payload?.duration ?? 4000}
				message={
					payload && (
						<View style={styles.webContent}>
							<ImageIcon
								name={payload.success ? 'success' : 'error'}
								width={16}
								height={16}
								style={{ marginLeft: 16 }}
							/>
							<I18n size={14} color='white' weight='normal' style={{ flexShrink: 1 }}>
								{payload.message}
							</I18n>
						</View>
					)
				}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				ContentProps={{
					style: {
						direction: 'rtl',
						backgroundColor: colors.primaryDarkBlue,
						color: '#fff',
						fontSize: '14px',
						letterSpacing: 0.25,
						fontWeight: '400',
						borderRadius: '8px',
					},
				}}
			/>
		);
	}

	return (
		<Portal>
			<RNSnackbar
				visible={!!payload}
				onDismiss={hide}
				duration={payload?.duration ?? 4000}
				style={{ backgroundColor: colors.primaryDarkBlue, borderRadius: 8 }}
			>
				{payload && (
					<View style={styles.mobileContent}>
						<I18n size={14} color='white' weight='normal' style={{ flexShrink: 1 }}>
							{payload.message}
						</I18n>
						<ImageIcon
							name={payload.success ? 'success' : 'error'}
							width={16}
							height={16}
							style={{ marginLeft: 16 }}
						/>
					</View>
				)}
			</RNSnackbar>
		</Portal>
	);
};

const styles = StyleSheet.create({
	webContent: {
		width: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	mobileContent: {
		width: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
});

export default SnackbarContainer;
